module.exports = __webpack_public_path__ + "static/img/ry2.57c5e465.png";